export default __webpack_public_path__ + "static/media/pdf-icon.6ae45e9a.jpg";